import React from "react";
import "./HomePage.css";
import HomePageLayout from "../../layouts/HomePageLayout/HomePageLayout";
import Intro from "../../components/Intro/Intro";
import About from "../../features/About/About";
import Projects from "../../features/Projects/Projects";
import Experience from "../../features/Experience/Experience";
import Contact from "../../features/Contact/Contact";
import SkillSwiper from "../../features/SkillSwiper/SkillSwiper";
import Achievements from "../../features/Achievements/Achievements";

const HomePage = () => {
  return (
    <>
      <HomePageLayout>
        <Intro />
        <About />
        <Experience />
        <Achievements />
        <section id="skills" className="skill-section">
         <SkillSwiper />
        </section>
        <Projects />
        <Contact/>
      </HomePageLayout>
    </>
  );
};

export default HomePage;
